export const prodButtons = {
  energy: {},
  leads: {},
}

export const telcoButtons = {
  mobileOnly: {
    prepaid: {
      residential: true,
    },
    postpaid: {
      residential: true,
      pro: true,
    },
  },
}

export const devButtons = {
  energy: {},
  leads: {},
  mobileOnly: {
    prepaid: {
      residential: true,
    },
    postpaid: {
      residential: true,
      pro: true,
    },
  },
}
